<div class="d-flex align-items-center" *ngIf="data$.countries as countries">
  <ng-container *ngIf="data && data.length < 248; else allCountries">
    <p500-ui-many-items
      [data]="data"
      i18n-title="@@common.all_counties"
      title="All Countries"
      [tmpl]="tmpl"
      [previewTmpl]="previewTmpl"
    ></p500-ui-many-items>
  </ng-container>

  <ng-template let-data="data" #tmpl>
    <div class="font-headline-5 d-flex">
      <img src="{{ countries[data]?.img }}" width="20" height="20" />
      &nbsp;&nbsp;
      {{ countries[data]?.name }}
    </div>
  </ng-template>
</div>

<ng-template let-data="data" #previewTmpl>
  <gtd-ui-field-default-country [data]="data"></gtd-ui-field-default-country>
</ng-template>

<ng-template #allCountries>
  <img src="/assets/new-img/flags/all.svg" width="32" height="16" class="mr-8" />
  <span class="text-color text-color--gray" i18n="@@common.all_countries">All Countries</span>
</ng-template>
